import factory from './icon';
import Svg from './glyphs/customer-service.svg';

export default factory(Svg);
